// extracted by mini-css-extract-plugin
export default {"iconContainer":"sjbRoy","playTriangle":"cpfXD2","playBackground":"K97017","iconPath":"Sct4Yn","svgContainer":"epxuXN"};